/**
 * Opções padrão do `useQueryParams` nas telas de relatório.
 *
 * - `replaceIn`: mexer nos filtros não empilha entradas no histórico, então o
 *   botão voltar do navegador sai da tela em vez de desfazer filtro a filtro.
 * - `removeDefaultsFromUrl`: mantém a URL curta e compartilhável, só com o que
 *   difere do padrão.
 */
export const reportQueryOptions = {
  updateType: 'replaceIn',
  removeDefaultsFromUrl: true,
};

export default reportQueryOptions;
